export const SUPPORTED_BUNDLES = ['x5', 'x10', 'x25'];

export const BUNDLE_BONUSES = {
  x5: 30,
  x10: 80,
  x25: 210,
};

export const INTERNAL_CURRENCIES = ['LOOTGEM', 'LOOTCOIN', 'FREE'];

export const TICKET_PAYMENT = 'TICKET_PAYMENT';

export const CURRENCY_I18N_IDS = {
  LOOTCOIN: 'LootCoins',
  LOOTGEM: 'Diamonds',
  FREE: 'LootPrice_free',
  ticket: 'loot_tickets',
};
